import { SSO_ROLE_CONSTANT } from "../../components/Mangement/modal/CreateAndEditNotify/FormDataConstants";
import {
  getinitNotificationFeatures,
  getinitUserControlFeatures,
} from "../helper/UserSliceHelper";
import { IAppFeatures, ISSOUser } from "../UserSlice";

export const DefineUserFeatures = (
  user: ISSOUser | null,
  activeRole: string
): IAppFeatures => {
  let features: IAppFeatures = {
    notification: getinitNotificationFeatures(),
    userControl: getinitUserControlFeatures(),
  };

  if (!user || user.ssoRoles.length === 0) {
    return features;
  }

  if (activeRole === SSO_ROLE_CONSTANT.admin) {
    //defining the notification features
    features.notification.accessNotificationBoard = true;
    features.notification.createNotify = true;
    features.notification.viewNotify = true;
    features.notification.editNotify = true;
    features.notification.deleteNotify = true;
    features.notification.submitNotify.level1 = true;
    features.notification.submitNotify.level2 = true;
    features.notification.assignNotify.level1 = true;
    features.notification.publishNotify.level1 = true;
    features.notification.rejectNotify.level1 = true;
    features.notification.recallNotify.level1 = true;

    //defining the user control features
    features.userControl.viewUserControl = true;
  } else if (activeRole === SSO_ROLE_CONSTANT.broadCast) {
    //defining the notification features
    features.notification.accessNotificationBoard = true;
    features.notification.viewNotify = true;
    features.notification.assignNotify.level2 = true;
    features.notification.publishNotify.level2 = true;
    features.notification.rejectNotify.level2 = true;
    features.notification.recallNotify.level2 = true;

    //defining the user control features
    //No features
  }

  return features;
};
